"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Titlebar = function Titlebar(props) {
  var _a, _b, _c, _d;
  var title = props.title,
    titleClassName = props.titleClassName,
    titleLineClamp = props.titleLineClamp,
    desc = props.desc,
    description = props.description,
    descLineClamp = props.descLineClamp,
    right = props.right,
    rightClassName = props.rightClassName,
    prefix = props.prefix,
    suffix = props.suffix,
    subTitleClassName = props.subTitleClassName,
    descClassName = props.descClassName,
    _e = props.show,
    show = _e === void 0 ? true : _e,
    _f = props.size,
    size = _f === void 0 ? 3 : _f,
    rowGap = props.rowGap,
    descSize = props.descSize,
    descType = props.descType,
    restProps = __rest(props, ["title", "titleClassName", "titleLineClamp", "desc", "description", "descLineClamp", "right", "rightClassName", "prefix", "suffix", "subTitleClassName", "descClassName", "show", "size", "rowGap", "descSize", "descType"]);
  if (!show) {
    return null;
  }
  var isHeading = +size < 7;
  var isH7 = +size === 7;
  var hTag = isHeading ? "h".concat(size) : 'div';
  var Tag = hTag; // eslint-disable-line
  var descNode = description || desc;
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-titlebar', {
      'with-desc': descNode,
      'with-right use-grid': right
    }),
    supportAllEvents: true
  }, Titlebar)), react_1["default"].createElement(Tag, {
    className: (0, classnames_1["default"])('odc-titlebar-title', (_a = {}, _a["spaui-h".concat(size)] = isHeading || isH7, _a['odc-line-clamp break-all'] = titleLineClamp, _a), titleClassName),
    title: typeof title === 'string' ? title : '',
    style: (_b = {}, _b['--odc-line-clamp'] = titleLineClamp, _b)
  }, prefix ? prefix : null, title, suffix ? suffix : null), right && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-titlebar-right', rightClassName)
  }, right), descNode ? react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-titlebar-desc', subTitleClassName, descClassName, (_c = {}, _c["odc-text-".concat(descSize)] = descSize, _c["odc-text-".concat(descType)] = descType, _c['odc-line-clamp break-all'] = descLineClamp, _c)),
    title: typeof descNode === 'string' ? descNode : '',
    style: (_d = {}, _d['--odc-row-gap'] = typeof rowGap === 'number' ? "".concat(rowGap, "px") : rowGap, _d['--odc-line-clamp'] = descLineClamp, _d)
  }, descNode) : null);
};
(0, spaui_utils_1.setComponentMark)(Titlebar, info_1["default"]);
exports["default"] = react_1["default"].memo(Titlebar);